import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import MessageRow from './message-row'
import AutoMessageModal from './auto-message-modal'
import BottomPagination from '../bottom-pagination'
import FlashAlert from '../flash-alert'
import { ajaxPut } from '../../ajax'
import Search from './search'

const GameAutoMessages = props => {
  const [loading, setLoading] = useState(false)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [messageToEdit, setMessageToEdit] = useState()
  const [query, setQuery] = useState()
  const [alert, setAlert] = useState(null)

  useEffect(() => { if (!props.locations.length) props.loadLocations() }, [])

  const onEdit = message => {
    setMessageToEdit(message)
    setShowCreateModal(true)
  }

  const onClose = () => {
    setShowCreateModal(false)
    setMessageToEdit(null)
  }

  const onUpdate = async (data) => {
    setLoading(true)
    const response = await ajaxPut(`/admins/game_auto_messages/${data.id}`, { game_auto_message: data })
    const json = await response.json()
    props.onUpdate(json.game_auto_message)
    setLoading(false)
    setAlert({ text: 'Game auto message updated.', type: 'success' })
  }

  return (
    <div className={`game-auto-messages ${loading ? 'isLoading' : ''}`}>
      { loading && <div className='animated-spinner' /> }
      { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} /> }
      <div className='game-auto-messages-header'>
        <h1>Auto Messages</h1>
        <div className='header-right'>
          <Search
            onSearch={(v) => {
              setQuery(v)
              props.onSearch(v)
            }}
          />
          <div className='buttons-container'>
            <button className='new-message' onClick={() => setShowCreateModal(true)}>
              <i className='fa fa-plus' />
              Add New
            </button>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-lg-12'>
          <table className='table'>
            <thead>
              <tr>
                <th>AUTOMATION</th>
                <th>LOCATIONS</th>
                <th>TIME TRIGGER</th>
                <th>ZIPWHIP</th>
                <th>DIRECT MESSAGE</th>
                <th>GROUP CHAT</th>
                <th>SMS (No App)</th>
                <th>EDIT</th>
                <th>DELETE</th>
              </tr>
            </thead>
            <tbody>
              {props.gameAutoMessages.map((message, index) =>
                <MessageRow
                  key={index}
                  message={message}
                  onDelete={props.onDelete}
                  onEdit={onEdit}
                  onUpdate={onUpdate}
                />
              )}
            </tbody>
          </table>
        </div>
      </div>
      <BottomPagination
        onPageChange={(page) => props.onPageChange({page: page, query: query})}
        totalCount={props.totalCount}
        perPage={props.perPage}
        page={props.page}
      />
      { showCreateModal &&
        <AutoMessageModal
          onClose={onClose}
          onCreate={props.onCreate}
          onUpdate={onUpdate}
          message={messageToEdit}
          locations={props.locations}
        />
      }
    </div>
  )
}

GameAutoMessages.propTypes = {
  gameAutoMessages: PropTypes.array.isRequired
}

export default GameAutoMessages
